let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("33w3O")).then(() => parcelRequire('h4r0z'));